const normalizeMessage = (message: string): string => message.toLowerCase().replace(/[’]/g, "'")

/**
 * Supports both the canonical backend marker and legacy human-readable
 * messages still present in some deployed environments.
 */
export const isProvisioningPendingMessage = (message: unknown): boolean => {
  if (typeof message !== 'string') return false

  const normalized = normalizeMessage(message)
  if (normalized.includes('user_provisioning_pending')) return true

  return normalized.includes('valid in aws cognito') && normalized.includes("doesn't exist in salesforce")
}
